<template>
    <div>
        <v-card>
            <v-alert class="mt-12" color="primary" dark border="left">
            GYM VIRTUAL DE INTELIGENIO
            </v-alert>
        </v-card>
        <v-row class="gap-3 d-flex mt-15">
            <router-link 
                v-for="(level, index) in nivelesCards" 
                :key="index" 
                :to="{ name: 'gymVirtualList', params: { title: level.title, nivel: level.nivel, estudianteData:estudianteData } }"
                class="router-link ml-5"
            >
            <v-card width="250" class="my-card rounded-lg elevation-10">
                <img :src="level.resources[0].iframeSrc" height="300" width="100%" alt="">
                <v-card-title class="d-flex justify-center py-2" >{{level.title}} </v-card-title>
            </v-card>
        </router-link>
        </v-row>
    </div>
</template>

<script>
// import axios from '../../../helpers/axios'
import {mapState} from 'vuex';


export default {
    
    components:{
    },
    
    data: () => ({
    nivelesCards : [
    {
        title: 'Primaria',
        nivel: 'Primaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/1.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
            
        ]
    },
    {
        title: 'Secundaria',
         nivel:'Secundaria',
        // grado:'3er grado',
        resources: [
            { 
                iframeSrc: 'https://s3-inteligenio-beta.s3.amazonaws.com/recurso/GymVirtual/2.png',
                description: 'DescripciÃ³n del recurso 1 para el gym virtual'
            },
           
        ]
    },
 
    ],
    estudianteResponse:[],
    
    
    }),


    mounted() {
          
    },
    computed: {
    ...mapState('globals', ['id_colegio', 'id_usuario']),
    estudianteData() {
      return { level: this.$route.params.level, estudianteData: this.$route.params.estudianteData };
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: '' });
    },
  },
  async clearProfileData() {
            localStorage.removeItem('gymvirtualParams');
        },
        async localStorageDataSave(selectedLevel, estudianteData){
            this.clearProfileData();
            localStorage.setItem('gymvirtualParams', JSON.stringify({level:selectedLevel, estudianteData: estudianteData}));
        },
};
</script>

<style scoped>
.my-card{
    transition: transform 0.3s ease;
    cursor: pointer;
    margin-top: 20px;
    margin-bottom: 20px; 
}

.my-card:hover{
    transform: scale(1.05);
}

.router-link{
    text-decoration: none;
}
.v-row {
    margin-bottom: 30px;
}
</style>